var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService4Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twinkle-lights 1",
    clipPath: "url(#clip0_17_193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Twinkle",
    d: "M8.75 0V2.5M8.75 2.5C8.75 7.3325 4.8325 11.25 0 11.25C4.8325 11.25 8.75 15.1675 8.75 20M8.75 2.5C8.75 7.3325 12.4175 11.25 17.25 11.25C12.4175 11.25 8.75 15.1675 8.75 20M8.75 22.5V20M25.75 14.75C25.75 18.2018 22.9518 21 19.5 21C22.9518 21 25.75 23.7982 25.75 27.25M25.75 14.75V12.25M25.75 14.75C25.75 18.2018 28.5482 21 32 21C28.5482 21 25.75 23.7982 25.75 27.25M25.75 29.75V27.25M23.5 0V7.5M19.75 3.75H27.25M13.5 24.5V32M9.75 28.25H17.25M2.5 23.5H0",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService4Icon);
export default __webpack_public_path__ + "static/media/service-4-icon.d39c20ecef96d3dbfefc357e0136199c.svg";
export { ForwardRef as ReactComponent };